<template>
  <q-page padding>
    <PageHeader
      title="Nova Criação de Picking"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Unidade Origem</div>

        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md col-sm-5 col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Unidade Destino</div>
        <q-select
          dense
          outlined
          option-label="nome"
          behavior="menu"
          v-model="filtros.unidadeDestino"
          :options="$store.state.org.todaUnidades"
        />
      </div>
      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Numero Requisição</div>
        <q-input
          dense
          outlined
          class="texto-titulo-input"
          v-model="filtros.requisicao"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>

      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Data Criação</div>
        <q-input
          v-model="filtros.dataCriacao"
          dense
          outlined
          class="texto-titulo-input"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          :rules="[
            (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
          ]"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataCriacao"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  :rules="[
                    (val) =>
                      val == '' || val.length == 10 || 'Digite a Data Completa',
                  ]"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-sm q-gutter-sm"
    >
      <div class="col-md col-sm-5 col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Solicitante</div>

        <SelecaoSolicitante @emitirFuncionario="receberFuncionario" />
      </div>
      <div class="col-md col-sm-5 col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Centro de Custo</div>

        <q-select
          v-model="filtros.centro"
          option-label="name"
          option-value="code"
          label-color="grey-6"
          behavior="menu"
          :options="centroOptions"
          dense
          outlined
          input-debounce="0"
          @filter="filterFn"
          use-input
        />
      </div>

      <div class="col-md col-sm-6 col-xs-6 input-unidade-container">
        <div class="texto-titulo-input">Quantidade de Linhas</div>
        <q-select
          v-model="pagination.rowsPerPage"
          option-label="label"
          option-value="value"
          label-color="grey-6"
          behavior="menu"
          :options="quantidadePaginas"
          dense
          outlined
        />
      </div>
      <div class="col-md col-sm-5 col-xs-5 input-unidade-container">
        <div class="texto-titulo-input">Turno</div>

        <q-input
          dense
          outlined
          class="texto-titulo-input"
          v-model="filtros.turno"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
        Listagem de Requisições
      </div>
      <div class="row col-12 justify-between q-mt-md" v-if="mobile">
        <q-btn
          no-caps
          label="Selecionar Todos"
          color="blue"
          icon="add"
          class="btn-grid"
          @click="selecionarTodos()"
        />
        <q-btn
          no-caps
          label="Remover Todos"
          color="red"
          icon="close"
          class="btn-grid"
          @click="(selected = []), (selecionados = [])"
        />
      </div>
      <q-table
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        dense
        color="primary"
        row-key="voucherId"
        flat
        :class="{ 'tabela-tamanho-fixo': !mobile }"
        :grid="mobile"
        v-model:pagination="pagination"
        hide-bottom
        no-data-label="Nenhuma requisição encontrada."
        selection="multiple"
        v-model:selected="selected"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-12">
            <div class="row card items-center">
              <div class="col">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Unidade:</strong>
                      {{ props.row?.unidadeNome }}
                    </span>
                    <span class="q-ml-sm"
                      ><strong>N.º Requisição:</strong>
                      {{ props.row.voucherId }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Colaborador:</strong>
                      {{ props.row?.solicitanteNome }}-{{
                        props.row?.solicitanteMatricula
                      }}
                    </span>
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Data:</strong>
                      {{
                        props.row?.criadoEm
                          ?.split(" ")[0]
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                      {{ props.row?.criadoEm?.split(" ")[1] }}
                    </span>
                  </div>
                  <div class="col-12">
                    <strong>Produtos:</strong>
                    <div
                      v-for="(produto, index) in props.row.produtos"
                      :key="index"
                      class="q-ml-md"
                    >
                      <strong>{{ produto.quantidade }} x </strong>
                      <span>{{ produto.codigo }} - {{ produto.nome }} </span>
                    </div>
                  </div>
                </q-card-section>
              </div>
              <div class="col-2 q-mr-sm text-center">
                <q-checkbox
                  color="brand-1"
                  v-model="selecionados"
                  size="xl"
                  :val="props.row.voucherId"
                  @click="atualizarSelecionados(props.row)"
                />
              </div>
            </div>
          </div>
        </template>
        <template #body-cell-produtos="props">
          <q-td :props="props">
            <div v-for="(produto, index) in props.row.produtos" :key="index">
              <span class="q-mt-sm"
                ><span style="font-weight: bolder">{{
                  produto.quantidade
                }}</span>
                x {{ produto.nome }}
                <span v-if="produto.localizacao">
                  x {{ produto.localizacao }}</span
                ></span
              >
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="row justify-center q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :direction-links="true"
        :size="mobile ? 'md' : 'sm'"
        :max-pages="6"
      />
    </div>

    <dialog-confirm
      mensagem="Tem certeza que deseja continuar?"
      :exibir="confirmacao"
      :propsClass="'q-pa-md'"
      @resultado="enviar"
    >
      <q-input
        v-model="observacao"
        dense
        style="width: 500px"
        outlined
        autogrow
        type="textarea"
        label="Observação"
      />
    </dialog-confirm>

    <div class="row col-12 q-mt-xl">
      <div>
        <q-btn
          label="Iniciar Picking"
          icon="add"
          color="positive"
          class="btn-grid"
          :disable="selected.length == 0"
          no-caps
          @click="confirmacao = true"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { watchDebounced } from "@vueuse/core";
import { useStore } from "vuex";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import DialogConfirm from "../components/DialogConfirm.vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoSolicitante,
    DialogConfirm,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    const columns = ref([
      {
        name: "unidadeNome",
        label: "Unidade",
        field: "unidadeNome",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "voucherId",
        label: "Numero Requisição",
        field: "voucherId",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },

      {
        name: "solicitanteNome",
        label:
          store.state.autenticacao.cliente[0] == "cerradinho" ||
          store.state.autenticacao.cliente[0] == "staging-cerradinho"
            ? "Colaborador"
            : "Solicitante",
        field: "solicitanteNome",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "centroCusto",
        label: "Centro de Custo",
        field: (row) =>
          row?.produtos[0]?.centroCusto
            ? row?.produtos[0]?.centroCusto?.codigo +
              " - " +
              row?.produtos[0]?.centroCusto?.descricao
            : "",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },

      {
        name: "turno",
        label: "Turno",
        field: (row) => row?.produtos[0]?.solicitanteVoucher?.turno,
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "produtos",
        label: "Produtos",
        field: "produtos",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "quantidadeProdutos",
        label: "Contagem de produtos",
        field: "quantidadeProdutos",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "valorTotal",
        label: "Valor Total Requisição",
        field: (row) =>
          row?.valorTotal?.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          }),
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "criadoEm",
        label: "Data Criação",
        field: (row) =>
          row.criadoEm != null
            ? row.criadoEm.split(" ")[0].split("-").reverse().join("/") +
              " " +
              row.criadoEm.split(" ")[1]
            : "",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
    ]);

    const filtros = ref({
      unidade: "",
      requisicao: null,
      reserva: null,
      dataCriacao: "",
      centro: "",
      deposito: "",
      localizacao: "",
      rejeicao: "",
      unidadeDestino: "",
      turno: "",
    });

    const observacao = ref("");
    const solicitanteMatricula = ref(null);
    const solicitantePesquisa = ref(null);
    const selected = ref([]);
    const rows = ref([]);
    const time = ref(null);

    const confirmacao = ref(false);
    const centroOptions = ref([]);

    const listaPicking = ref([]);

    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    const selecionados = ref([]);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile = ref(true);
    }

    const getDados = async (page = 1, rowsPerPage = 10) => {
      disable.value = true;
      try {
        let response = await store.dispatch("pkg/getListagemRequisicaoABB", {
          unidadeId: filtros.value?.unidadeDestino?.id,
          page: page,
          perPage: rowsPerPage,
          criadoEm: filtros.value.dataCriacao
            ? filtros.value.dataCriacao.split("/").reverse().join("-")
            : undefined,
          solicitanteNome:
            solicitanteMatricula.value && solicitanteMatricula.value.name
              ? solicitanteMatricula.value.name
              : undefined,
          ccDescricao: filtros.value.centro.name,
          voucherId: filtros.value.requisicao,
          reserva: filtros?.value?.reserva,
          localizacao: filtros?.value?.localizacao,
          deposito: filtros?.value?.deposito,
          desmembrado: filtros?.value?.rejeicao == "Sim" ? "sim" : "nao",
          solicitanteTurno: filtros.value.turno,
        });

        if (
          store.state.autenticacao.cliente[0] == "cerradinho" ||
          store.state.autenticacao.cliente[0] == "staging-cerradinho"
        ) {
          columns.value = columns.value.filter((value) => {
            if (value.name != "centroCusto" && value.name != "valorTotal") {
              return value;
            }
          });
        }

        rows.value = response.data.result.dados;
        pagination.value.rowsPerPage = response.data.result.perPage;
        pagination.value.rowsNumber = response.data.result.total;
        pagination.value.page = response.data.result.currentPage;

        disable.value = false;
      } catch (error) {
        disable.value = false;
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviar = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        let itens = [];
        try {
          itens = selected.value.map((value) => {
            return {
              voucherId: value.voucherId,
              produtos: value.produtos.map((produto) => {
                return {
                  productId: produto.produtoId,
                  quantidadeAtendida: produto.quantidade,
                };
              }),
            };
          });

          const response = await store.dispatch("pkg/iniciarPicking", {
            unidadeIdOrigem: filtros.value.unidade.id,
            unidadeIdDestino: filtros.value.unidadeDestino.id,
            observacao: observacao.value.replace(new RegExp("\\n", "gi"), " "),
            usuarioId: store.state.autenticacao.idBase,
            itens,
          });

          disable.value = false;
          router.push({
            name: "pkg-detalhe-nova",
            params: { id: response.data.result.pickingUuid },
          });
        } catch (error) {
          quasar.notify({
            message:
              error?.response?.data?.result?.error ==
              "Undefined index: unidadeIdDestino"
                ? "Informe a unidade de Destino"
                : error?.response?.data?.result?.error,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const receberFuncionario = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        filtros.value.unidade = JSON.parse(getunidade);
        getDados();
      }

      setTimeout(() => {
        if (
          store.state.autenticacao.cliente.includes("staging-cerradinho") ||
          store.state.autenticacao.cliente.includes("cerradinho")
        ) {
          filtros.value.unidadeDestino = store.state.org.todaUnidades[0];
        }
      }, 1000);
    };

    onMounted(getUnidade);

    const selecionarTodos = () => {
      rows.value.forEach((picking) => {
        if (
          !selected.value.some(
            (selecionado) => selecionado.voucherId == picking.voucherId
          )
        ) {
          selected.value.push(picking);
        }
      });
      rows.value.forEach((picking) => {
        if (
          !selecionados.value.some(
            (selecionado) => selecionado == picking.voucherId
          )
        ) {
          selecionados.value.push(picking.voucherId);
        }
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const getCentros = async (val) => {
      const response = await store.dispatch("pkg/getCentrosCustos", {
        search: val,
      });

      centroOptions.value = response.data.results.data;
    };

    const atualizarSelecionados = (linha) => {
      let indexSelecionado = selecionados.value.findIndex((value) => {
        return linha.voucherId === value;
      });
      let indexSelected = selected.value.findIndex((value) => {
        return value.voucherId === linha.voucherId;
      });

      if (indexSelecionado != -1) {
        selected.value.push(linha);
        return;
      }
      selected.value.splice(indexSelected, 1);
    };

    onMounted(getCentros);

    watchDebounced(
      [
        () => filtros.value.dataCriacao,
        () => filtros.value.centro,
        () => filtros.value.requisicao,
        () => filtros.value.reserva,
        () => solicitanteMatricula.value,
        () => pagination.value.rowsPerPage,
        () => pagination.value.page,
        () => filtros?.value?.localizacao,
        () => filtros?.value?.deposito,
        () => filtros?.value?.rejeicao,
        () => filtros.value.unidadeDestino,
        () => filtros.value.turno,
      ],
      () => {
        if (
          filtros.value.dataCriacao != "" &&
          filtros.value.dataCriacao.length != 10
        ) {
          return;
        }
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      getUnidade,
      receberFuncionario,
      solicitanteMatricula,
      solicitantePesquisa,
      filtros,
      listaPicking,
      pagination,
      disable,
      selected,
      selecionarTodos,
      columns,
      mobile,
      getDados,
      handleRequest,
      atualizarSelecionados,
      selecionados,
      centroOptions,
      rejeicaoOptions: [
        { label: "Sim", value: "sim" },
        { label: "Não", value: "nao" },
      ],
      listaTurnos: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Turno A",
          value: 8,
        },
        {
          label: "Turno B",
          value: 9,
        },
      ],
      quantidadePaginas: ["10", "30", "50", "70", "100", "200", "500", "1000"],
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      confirmacao,
      enviar,
      rows,
      observacao,
      filterFn(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getCentros(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>

<style scoped>
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-coluna-card {
  font-size: 14px;
}
.texto-titulo {
  font-size: 20px;
}
.card {
  border: 1px solid #707070;
}
.text-grid-table {
  font-size: 19px;
}

@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 16px;
  }
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .titulo-tabela {
    font-size: 15px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .btn-grid {
    font-size: 15px;
  }
  .text-grid-table {
    font-size: 15px;
  }
}
</style>
